import { render } from "./AdminConsents.vue?vue&type=template&id=51dabb58"
import script from "./AdminConsents.vue?vue&type=script&lang=js"
export * from "./AdminConsents.vue?vue&type=script&lang=js"

import "./AdminConsents.vue?vue&type=style&index=0&id=51dabb58&lang=css"

import exportComponent from "D:\\Pragmasoft\\zntry.consent\\src\\Zntry.Consent.Website\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__